import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { ChallengeService } from '../../services/challenge.service';
import { ClassificationService } from '../../services/classification.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
//export const stats = writable<IDossierStatsDTO>(null);
export const stats = writable(null);
export const clfChallengeTypeCode = writable("");
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    clfChallengeTypeCode.set("");
    //stats.set(null);
    if (oid == 0) {
        record.set({ oid: 0, name: '', active: 1, difficulty: 0, runtimeMs: 1000, memoryMb: 32, clfComparatorId: 0, clfChallengeTypeId: 0, statement: '', programText: '', order: 0, sectionId: 0 });
    }
    else {
        let _resp = await ChallengeService.fetchChallenge(oid);
        record.set(_resp.payload);
        await loadStats(oid);
        await onChallengeTypeChange(); // initial load
    }
}
async function loadStats(challengeOid) {
    // let _resp = await ChallengeService.fetchChallengeStats(challengeOid);
    //stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await ChallengeService.getChallenges(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/challenge/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/challenge/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await ChallengeService.saveChallenge(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await ChallengeService.deleteChallenge(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export async function onChallengeTypeChange() {
    let _record = get(record);
    let code = "";
    try {
        if (_record.clfChallengeTypeId > 0) {
            let _res = await ClassificationService.fetchValue(_record.clfChallengeTypeId);
            if (_res && _res.payload) {
                code = _res.payload.code;
            }
        }
    }
    catch (e) {
        // ignore
    }
    clfChallengeTypeCode.set(code);
}
